import Immutable from 'seamless-immutable'
import { snakeCase, } from 'lodash'
import { takeLatest, takeEvery } from 'redux-saga/effects'
import { createReducer, } from './utils'
import { PENDING, } from './constants'


/**
 * Alternative to create a module
 */
export const createModule = (config) => {
  // Initial State
  const initialState = Immutable(config.state)
  let actionCreators = {}
  let actionsTypes   = {}
  let actionHandlers = {}
  let effects = {}
  let sagas = []

  Object.keys(config.handlers).map(actionName => {
    //Action Type
    const actionType = `@${config.name}/${snakeCase(actionName).toLocaleUpperCase()}`
    actionsTypes[actionName] = actionType

    let onlyHandler = (actionName) => {
      let isActionType = actionName.indexOf('@') > -1
      let isValidName  = actionName.indexOf('/') === -1

      return (isActionType || !isValidName)
    }

    //Action Creator
    if (!onlyHandler(actionName)) {
      if (config.effects && config.effects[actionName]) {
        actionCreators[actionName] = (data, status) => ({
          type: actionType,
          payload: data,
          status,
        })
      } else {
        actionCreators[actionName] = (data) => ({
          type: actionType,
          payload: data,
        })
      }
    }

    //Acion Handler for reducer
    if (onlyHandler(actionName)) {
      actionHandlers[actionName] = config.handlers[actionName]
    } else {
      actionHandlers[actionType] = config.handlers[actionName]
    }

    //Effects
    if (config.effects && config.effects[actionName]) {
      let callback = config.effects[actionName].callback
      
      const effect = config.effects[actionName].type === 'all' ? takeEvery : takeLatest

      sagas.push(
        effect((action) => {
          return action.type === actionType && (!action.status || action.status === PENDING)
        }, callback, actionCreators)
      )

      effects[actionName] = callback
    }
  })

  // We set the "free" effects. This are effect that doen't match with the handlers in the model.
  Object.keys(config.effects).map(eff => {
    let isActionType = eff.indexOf('@') > -1
    let isValidName  = eff.indexOf('/') === -1

    let isActionName =  (isActionType || !isValidName)

    //If the action doesn't exist and the effect its an action name (@model/action)
    if (!config.handlers[eff] && isActionName) {
      let callback = config.effects[eff].callback
      const effect = config.effects[eff].type === 'all' ? takeEvery : takeLatest

      sagas.push(
        effect((action) => {
          return action.type === eff && (!action.status || action.status === PENDING)
        }, callback, actionCreators)
      )

      effects[actionName] = callback
    }
  })

  const reducer = createReducer(
    initialState,
    actionHandlers
  )

  return {
    name: config.name,
    initialState,
    actionCreators,
    actionsTypes,
    actionHandlers,
    reducer,
    effects,
    sagas,
  }
}



// WEBPACK FOOTER //
// ./src/module.js